import React from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import serviceOneImage from '../../../assets/images/services/serviceOneImage/preConstructionServices.png';
import serviceTwoImage from '../../../assets/images/services/serviceTwoImage/generalContracting.png';
import serviceThreeImage from '../../../assets/images/services/serviceThreeImage/residentialAndCommercialConstruction.png';
import serviceFourImage from '../../../assets/images/services/serviceFourImage/jointVentureDevelopment.png';
import serviceFiveImage from '../../../assets/images/services/serviceFiveImage/repairsAndRenovations.png';
import serviceSixImage from '../../../assets/images/services/serviceSixImage/pantings.png';

const servicesData = [
    {
        title: "PRE-CONSTRUCION SERVICES",
        description: "We excel in general contracting, managing projects from inception to completion with precision and efficiency. Our end-to-end project management ensures seamless coordination, timely execution, and cost-effective solutions. With a strong commitment to safety compliance and quality control, we adhere to industry standards, ensuring secure and durable structures. Whether it’s a large-scale construction, a high-end renovation, or a bespoke interior project, we deliver excellence, reliability, and craftsmanship in every detail.",
        image: serviceOneImage
    },
    {
        title: "GENERAL CONTRACTING",
        description: "We provide comprehensive general contracting services, ensuring end-to-end project management with a focus on efficiency, transparency, and seamless execution. Our team oversees every aspect, from planning and procurement to execution and final delivery. We prioritize safety compliance and quality control, adhering to industry standards to create secure and long-lasting structures. Whether it’s new construction, renovation, or interior fit-outs, we guarantee excellence, precision, and reliability in every project we undertake.",
        image: serviceTwoImage
    },
    {
        title: "RESIDENTIAL & COMMERCIAL CONSTRUCTION",
        description: "We specialize in residential and commercial construction, delivering high-quality projects tailored to diverse needs. From custom home construction to apartment and condominium development, we create spaces that blend functionality with aesthetics. Our expertise extends to office buildings, commercial spaces, industrial facilities, and warehouses, ensuring durability and efficiency. With a commitment to superior craftsmanship, innovative design, and industry-best practices, we build structures that stand the test of time while meeting modern demands.",
        image: serviceThreeImage
    },
    {
        title: "JOINT VENTURE DEVELOPMENT",
        description: "We excel in joint venture development, collaborating with partners to create high-value residential, commercial, and industrial projects. By leveraging combined expertise, resources, and innovative strategies, we maximize investment potential while ensuring efficiency and quality. Our approach focuses on strategic planning, seamless execution, and risk management, delivering developments that meet market demands. With a commitment to excellence, we create sustainable and profitable ventures that stand the test of time.",
        image: serviceFourImage
    },
    {
        title: "REPAIRS & RENOVATIONS",
        description: "We specialize in renovation and remodeling, transforming spaces with precision and creativity. From home and office renovations to kitchen and bathroom remodeling, we enhance functionality and aesthetics. Our expertise extends to structural repairs, upgrades, and historic restoration, preserving architectural integrity while incorporating modern enhancements. With a commitment to quality craftsmanship and attention to detail, we ensure every renovation project meets the highest standards of durability, beauty, and efficiency.",
        image: serviceFiveImage
    },
    {
        title: "PAINTINGS",
        description: "We provide professional painting services, enhancing residential, commercial, and industrial spaces with precision and durability. From interior and exterior painting to decorative finishes and protective coatings, we use high-quality materials and advanced techniques to achieve flawless results. Our expertise extends to wall textures, waterproofing, and restoration painting, ensuring longevity and aesthetic appeal. With a focus on detail, color harmony, and craftsmanship, we create visually stunning and enduring finishes for every project.",
        image: serviceSixImage
    },
];

const ServicesContentCard = () => {
    return (
        <div className="services-main-content">
            {servicesData.map((service, index) => (
                <div key={index} className="services-card">
                    <div className="services-contents">
                        <div className="services-description">
                            <h1>{service.title}</h1>
                            <p>{service.description}</p>
                            {/* <button className="services-learn-more-button">
                                Learn More →
                            </button> */}
                        </div>
                        <div className="services-image-container">
                            <LazyLoadImage
                                draggable={false}
                                src={service.image}
                                alt={service.title}
                                effect="blur"
                                style={{ objectFit: 'cover' }}
                            />
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ServicesContentCard;
